import useShowDialogAlert from "components/DialogAlert/utils/hooks/useDialogAlert";
import { useState } from "react";

const useSchedulesWithCrossings = ({
    toStep
}) => {
    const [schedulesWithCrossings, setSchedulesWithCrossings] = useState([]);
	const dialog = useShowDialogAlert();
    const showDialog = (schedulesWithCrossings) => {
        setSchedulesWithCrossings(schedulesWithCrossings);
        dialog.set(true);
    }
    const goToUpdateDuration = () => {
        dialog.set(false);
        toStep(1);
    }
    return {
        forComponent: {
            dialog,
            schedulesWithCrossings,
            goToUpdateDuration
        },
        showDialog
    };
}	
    
export default useSchedulesWithCrossings;